<script setup>
const backend = useBackend();
const route = useRoute();

const props = defineProps({
  noVehisLogos: {
    type: Boolean,
    default: false
  },
})

const footerLinks = [
  { slug: 'polityka-prywatności', title: 'Polityka prywatności' },
  { slug: 'zgoda-bik', title: 'Zgoda BIK' },
]

const isOfferPage = computed(() => route.name === "offer")
</script>

<template>
  <div class="bg-black  text-xs text-white" :class="{'pb-16 lg:pb-0' : isOfferPage}">
    <Container no-paddings>
      <div class="flex justify-between gap-6 py-6 flex-col lg:flex-row">

        <div class="md:flex md:gap-8 items-center | grid grid-cols-2 gap-10">
          <div v-if="!noVehisLogos">
            <VectorVehisOnly white />
          </div>
          <div>&copy; 2025 VEHIS sp. z o.o.</div>
        </div>

        <div class="md:flex lg:gap-8 gap-x-10 gap-y-4 | grid grid-cols-2">
          <div v-for="link in footerLinks" :key="link.slug">
            <NuxtLink 
              :to="{name:'document', params: {slug: link.slug }}" 
              rel="noindex"
            >
              {{ link.title }}
            </NuxtLink>
          </div>
        </div>

      </div>
    </Container>
  </div>
</template>
